import EventOps2Core from './EventOps2Core';
import withEventOpsAutoLoad from './withEventOpsAutoLoad';
import withErrorCatcher from './withErrorCatcher';
import withRequiredFields from './withRequiredFields';

export default withErrorCatcher(withEventOpsAutoLoad(withRequiredFields(EventOps2Core)));
